import { useMemo, type CSSProperties } from 'react'
import * as React from 'react'

import StaticPropertyMapWithInteractiveModal from 'components/Common/PropertyMap/StaticPropertyMapWithInteractiveModal'
import type { PropertyMapOptions } from 'components/Common/PropertyMap/types'
import Group from 'components/utils/Group'
import { nonNullable } from 'lib/array/arrayUtils'
import { MAPBOX_ACCESS_TOKEN_USE_CASES } from 'lib/maps/mapboxAccessToken'

interface Props {
  primaryMapMarker?: App.MapMarker
  pickupMapMarker?: App.MapMarker
  locationMapMarkerList?: Array<App.MapMarker>
  style: CSSProperties & { height: number }
  modalTitle: string
}

const MAP_OPTIONS: PropertyMapOptions = {
  fullscreenControl: false,
}

function ExperienceMap(props: Props) {
  const {
    primaryMapMarker,
    pickupMapMarker,
    locationMapMarkerList,
    style,
    modalTitle,
  } = props

  const markers = useMemo(() => {
    return nonNullable([
      primaryMapMarker && {
        ...primaryMapMarker,
        openGoogleMapsOnSelect: false,
      },
      pickupMapMarker && {
        ...pickupMapMarker,
        openGoogleMapsOnSelect: false,
      },
      ...(locationMapMarkerList ?? []).map((marker) => ({
        ...marker,
        openGoogleMapsOnSelect: false,
      })),
    ])
  }, [locationMapMarkerList, pickupMapMarker, primaryMapMarker])

  return <Group direction="vertical">
    <StaticPropertyMapWithInteractiveModal
      height={style.height}
      wrapperStyle={style}
      markers={markers}
      modalTitle={modalTitle}
      multipleMarkers
      mapOptions={MAP_OPTIONS}
      showActiveMarkerState={false}
      mapboxAccessTokenUseCase={MAPBOX_ACCESS_TOKEN_USE_CASES.experiences}
    />
  </Group>
}

export default ExperienceMap
